// extracted by mini-css-extract-plugin
export default {"content":"mW0v","left":"A511","chat":"UeY5","right":"_Rx1","rightOpen":"la8a","rightOverlay":"_3hiL","rightOverlayOpen":"_1iyY","noContent":"_3Ppt","blockButton":"_13S1"};